/// <reference path="../typings/tsd.d.ts" />




//var jsShims = require( "./core/jsshims" );
//import * as jsShims from  "./core/jsshims.js" 

///** allows embeding mocha tests (unit tests) in your code, no-oping them if mocha is not present.  */
import * as mockMocha from "./core/diagnostics/mockmocha.js";
mockMocha._initialize();

//var source_map_support = require( "source-map-support" );
//import source_map_support from "source-map-support";

import * as lolo from "./core/lolo.js"; export { lolo };
// if ( lolo.isDebug === true || lolo.isDev === true ) {
//     //try {
//     ///** https://www.npmjs.com/package/source-map-support
//     // * This module provides source map support for stack traces in node via the V8 stack trace API. It uses the source-map module to replace the paths and line numbers of source-mapped files with their original paths and line numbers. The output mimics node's stack trace format with the goal of making every compile-to-JS language more of a first-class citizen. Source maps are completely general (not specific to any one language) so you can use source maps with multiple compile-to-JS languages in the same node process.
//     //  */
//     console.log( "loading sourcemap support (in logLevel.DEBUG or envLevel.DEV)" );

//     source_map_support.install(
//         {
//             handleUncaughtExceptions: false,
//             hookRequire: true,
//         }
//     );
//     //} catch (ex) {
//     //	console.log("eating sourcemap support call");
//     //}
// }

///** low-level javascript helpers, to smooth over warts in the language */
import * as jsHelper from "./core/jshelper.js"; export { jsHelper };
//jsHelper.initialize();
import * as arrayHelper from "./core/arrayhelper.js"; export { arrayHelper };
//import {} ClassBase from "./core/classbase.js"; export { ClassBase };
export * from "./core/classbase.js";
import * as diagnostics from "./core/diagnostics.js"; export { diagnostics };
import * as exception from "./core/exception.js"; export { exception };
import * as collections from "./core/collections.js"; export { collections };

/** various math and numerical conversion/manipulation related helper functions */
import * as numHelper from "./core/numhelper.js"; export { numHelper };
import * as stringHelper from "./core/stringhelper.js"; export { stringHelper };
import * as reflection from "./core/reflection.js"; export { reflection };
import * as environment from "./core/environment.js"; export { environment };
import * as lodash from "lodash"; export { lodash };
//set lodash as a global if it's not.
if ( environment.getGlobal()[ "_" ] == null ) {
    environment.getGlobal()[ "_" ] = lodash;
}

import * as dateTime from "./core/datetime.js"; export { dateTime };
if ( environment.getGlobal()[ "moment" ] == null ) {
    //define momentStatic
    environment.getGlobal()[ "moment" ] = dateTime.moment;
}

import * as validation from "./core/validation.js"; export { validation };
import * as serialization from "./core/serialization.js"; export { serialization };

//export import compression = require( "./core/compression" );
import * as threading from "./core/threading.js"; export { threading };


import * as promise from "./core/promise.js"; export { promise };

import * as net from "./core/net.js"; export { net };

import * as cache from "./core/cache.js"; export { cache };

/** templates for various design patterns */
import * as designPatterns from "./core/design-patterns/design-patterns.js"; export { designPatterns };

/** security and cryptographic helpers.   (cross-platform)
 *  note:  our ```KDF``` is nodejs only, and can be found in the ```nlib.security``` module.
 * */
import * as security from "./core/security.js"; export { security };
/** decimal.js: high precision numbers
https://www.npmjs.com/package/decimal.js
*/
import * as decimal from "decimal.js"; export { decimal };



// /** cross-platform implementation of the nodejs module: http://nodejs.org/api/events.html
//  * -------------------
//  * Many objects in Node emit events: a net.Server emits an event each time a peer connects to it, 
//  * a fs.readStream emits an event when the file is opened. All objects which emit events are instances of events.EventEmitter. 
//  * You can access this module by doing: require("events");
//  * Typically, event names are represented by a camel-cased string, however, 
//  * there aren't any strict restrictions on that, as any string will be accepted.
//  * Functions can then be attached to objects, to be executed when an event is emitted. 
//  * These functions are called listeners. Inside a listener function, 
//  * this refers to the EventEmitter that the listener was attached to.
//  */
// export import events = require( "events" );

/** cross-platform implementation of the nodejs module: http://nodejs.org/api/buffer.html 
 * -----------------
 * Pure JavaScript is Unicode friendly but not nice to binary data. When dealing with TCP streams or the file system, 
 * it's necessary to handle octet streams. Node has several strategies for manipulating, creating, 
 * and consuming octet streams.
 * Raw data is stored in instances of the Buffer class. 
 * A Buffer is similar to an array of integers but corresponds to a raw memory allocation outside the V8 heap. 
 * A Buffer cannot be resized.

The Buffer class is a global, making it very rare that one would need to ever require('buffer').
 */
import * as buffer from "buffer"; export { buffer };

/** cross-platform implementation of the nodejs module: http://nodejs.org/api/path.html
 * -------------------
 * This module contains utilities for handling and transforming file paths. 
 * Almost all these methods perform only string transformations. 
 * The file system is not consulted to check whether paths are valid.
 */
import * as path from "path"; export { path };

// /** cross-platform implementation of the nodejs module: http://nodejs.org/api/punycode.html
//  * -------------------
//  * Punycode is a way to represent Unicode with the limited character subset of ASCII supported by the Domain Name System. 
//  * For example "münich" would be encoded as "mnich-kva".
//  */
// export import punycode = require( "punycode" );


/** cross-platform implementation of the nodejs module: http://nodejs.org/api/querystring.html
 * -------------------
 * This module provides utilities for dealing with query strings.
 */
import * as querystring from "querystring"; export { querystring };

// /** cross-platform implementation of the nodejs module: http://nodejs.org/api/stream.html
//  * -------------------
//  * A stream is an abstract interface implemented by various objects in Node. 
//  * For example a request to an HTTP server is a stream, as is stdout. 
//  * Streams are readable, writable, or both. All streams are instances of EventEmitter
//  */
// export import stream = require( "stream" );

// /** cross-platform implementation of the nodejs module: http://nodejs.org/api/string_decoder.html
//  * -------------------
//  * StringDecoder decodes a buffer to a string. 
//  * It is a simple interface to buffer.toString() but provides additional support for utf8.
//  */
// export import string_decoder = require( "string_decoder" );

/** cross-platform implementation of the nodejs module: http://nodejs.org/api/url.html
 * -------------------
 * This module has utilities for URL resolution and parsing. 
 */
import * as url from "url"; export { url };

import * as definitions from "./definitions/definitions.js"; export { definitions };


/**
 * allows describing user input as a Class instead of a POJO, and enforces conformance of the class via templates.
 */
export abstract class PayloadTemplate<TThis>{

    constructor( jsonPayload?: string | Buffer, templateObj?: TThis,
        /** defaults: {parseOrphans:false,pruneOrphans:true,sanitizeStrings:true,maxInputLength:5000} 
        set to FALSE to not parse
        */
        templateParseOptions?: {
            reviver?: ( key: any, value: any ) => any;
            /** if true, an object can be passed in, not just a string or Buffer */
            allowObjectInput?: boolean;
            /** if true, attempts to parse any additional strings found in the input (and does this recursively) */
            parseOrphans?: boolean;
            /** if true, deletes any orphans found.  default = TRUE */
            pruneOrphans?: boolean;
            /** if true, will escape strings to prevent injection attacks.  default false.   to ignore pruning of a node's children, set that node to null.  ex: ```myTemplate.userTags=null``` */
            escapeStrings?: boolean,
            /** if set, throws an exception if the input is too long.  default=5000 */
            maxInputLength?: number;
            /** true to not validate that all template fields are present.  default=false*/
            skipValidation?: boolean;
        }
    ) {

        if ( jsonPayload == null ) {
            return;
        }

        if ( templateParseOptions == null ) {
            templateParseOptions = {}
        }
        lodash.defaults( templateParseOptions, { parseOrphans: false, pruneOrphans: true, escapeStrings: false, maxInputLength: 5000, skipValidation: false, } );

        let parsedObj: any;
        if ( templateObj != null ) {
            parsedObj = serialization.JSONX.parseUsingTemplate( templateObj, jsonPayload, templateParseOptions );
        } else {
            if ( jsonPayload instanceof Buffer ) {
                parsedObj = serialization.JSONX.parse( jsonPayload.toString() );
            } else {
                parsedObj = serialization.JSONX.parse( jsonPayload );
            }
        }
        lodash.assign( this, parsedObj );
        if ( templateParseOptions.skipValidation !== true ) {
            validation.scrub( this ).isTemplatePopulated( templateObj ).failThrow();
        }
    }


}
